import { saveUserInfo } from "./AuthUtils";
import { decodeUserInfo } from "./userInfoEncoding";

/**
 * Decode the base64 `info` query param handed back by the auth portal after
 * redirect, persist the raw (still-encoded) blob to localStorage, and return
 * the parsed user info.
 */
export function parseQueryParams(infoData) {
  try {
    if (infoData) {
      saveUserInfo(infoData);
      const userInfo = decodeUserInfo(infoData);
      if (!userInfo) return null;
      return { userInfo: userInfo };
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
}
